import { render, staticRenderFns } from "./RegisterOrganizationModal.vue?vue&type=template&id=1141cad1&scoped=true&"
import script from "./RegisterOrganizationModal.vue?vue&type=script&lang=ts&"
export * from "./RegisterOrganizationModal.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterOrganizationModal.vue?vue&type=style&index=0&id=1141cad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1141cad1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VOverlay,VProgressCircular,VRow,VSelect,VSwitch,VTextField})
